import * as React from 'react';
import clsx from 'clsx';
import roundCheck from '@/assets/images/svg/round_check.svg';
import roundUncheck from '@/assets/images/svg/round_uncheck.svg';

interface FeedbackOptionProps {
  id: string;
  label: string;
  checked: boolean;
  onChange: (id: string, checked: boolean) => void;
}

export const FeedbackOption: React.FC<FeedbackOptionProps> = ({ id, label, checked, onChange }) => (
  <label
    className={clsx(
      'flex w-full cursor-pointer items-center justify-between',
      'rounded-[10px] border px-4 py-3',
      'transition-colors',
      checked ? 'border-gray-310 bg-purple-250' : 'border-gray-310 bg-white'
    )}
  >
    <span className='font-sans text-16 font-normal leading-[27px] tracking-normal text-brand-800'>
      {label}
    </span>

    <input
      type='checkbox'
      checked={checked}
      onChange={(e) => onChange(id, e.target.checked)}
      className='peer sr-only'
    />

    <div className='relative flex size-5 shrink-0 items-center justify-center'>
      <img
        src={checked ? roundCheck : roundUncheck}
        alt={checked ? 'Checked' : 'Unchecked'}
        className='size-full object-contain'
      />
    </div>
  </label>
);
